export default __webpack_public_path__ + "static/media/ARM_frame_arm_5.383913ea.png";